import React from 'react'
import styled from 'styled-components'

import { theme, breakpoint } from '../styles'

import { SEO } from '../components'

import { MaxWidthWrapper } from '../components/layouts'

/* Containers  */
const WarrantyPageContainer = styled.section`
  background: ${theme.color.solid.white};
  color: ${theme.color.solid.pureblk};
`

const Wrapper = styled(MaxWidthWrapper)`
  margin: 0 auto;
  padding: 147px 8rem;

  @media (max-width: ${breakpoint.largeTablet}) {
    padding: 131px 7rem;
  }

  @media (max-width: ${breakpoint.largeMobile}) {
    padding: 67px 2.4rem;
  }
`
/* Headers */

const Header = styled.h2`
  text-align: center;
  margin-bottom: 0;

  @media (max-width: ${breakpoint.largeTablet}) {
    font-size: 3.8rem;
  }

  @media (max-width: ${breakpoint.largeMobile}) {
    font-size: 3.6rem;
  }
`

const LastModified = styled.h5`
  text-align: center;
  font-style: italic;
  margin-top: 8px;

  @media (max-width: ${breakpoint.largeTablet}) {
    font-size: 2.4rem;
  }

  @media (max-width: ${breakpoint.largeMobile}) {
    font-size: 1.4rem;
  }
`
/* Paragraphs */

const Paragraph = styled.p`
  font-size: 1.8rem;
  line-height: 3rem;

  @media (max-width: ${breakpoint.largeTablet}) {
    font-size: 1.4rem;
    line-height: 2.4rem;
  }

  @media (max-width: ${breakpoint.largeMobile}) {
    font-size: 1.2rem;
    line-height: 1.8rem;
  }
`

const WarrantyPage = () => (
  <>
    <SEO title="Warranty" />
    <WarrantyPageContainer>
      <Wrapper>
        <Header>WARRANTY</Header>
        <LastModified>Last modified: July 1st, 2020</LastModified>
        <Paragraph>
          Katalyst’s Training System components, including the vest, shorts and
          arm straps (including D-Rings, pads, snaps, straps, zipper, connector
          ports, buckles, loops, arm connectors), water dispenser, charger and
          charging cable are covered by our 1-year limited warranty starting on
          the date of original purchase, for the benefit of the original
          purchaser (proof of purchase is required) (the “Katalyst Training
          System Limited Warranty”). The impulse pack is covered by our 3-year
          limited warranty starting on the date of original purchase, for the
          benefit of the original purchaser (proof of purchase is required) (the
          “Impulse Pack Limited Warranty”). Under both the Katalyst Training
          System Limited Warranty and Impulse Pack Limited Warranty (together,
          the “Limited Warranties”), the covered components are warranted to be
          free from manufacturer defects excluding any damage or defects
          resulting from (a) normal wear and tear associated with the intended
          use, (b) commercial use and (c) failure to follow instructions in the
          instruction manual, accident, misuse, neglect, abuse, alterations,
          modification, improper assembly, installation or use of any
          non-original parts or accessories. The Impulse Pack Limited Warranty
          does not include damage from power surges, use of an improper charger,
          improper maintenance, or other such misuse or water damage. During the
          Limited Warranties applicable period, the manufacturer will replace
          faulty, covered components that are eligible under the Limited
          Warranties (as applicable), at no charge (shipping &amp; handling fees
          may apply). Warranty claims must be submitted to support@katalyst.fit.
          Please note that Katalyst will not replace any part without first
          seeing photos or video of the damaged part.
        </Paragraph>

        <Paragraph>
          Any implied warranties are limited to the duration of the Limited
          Warranty. Some states do not allow limitations on how long an implied
          warranty lasts, so the above limitation may not apply to you. In no
          event shall Katalyst be responsible for any indirect or consequential
          damages, including without limitation, damages for personal injury,
          property damage, or economic losses, whether based on contract,
          warranty, negligence, or product liability in connection with their
          products. Some states do not allow the exclusion or limitation of
          incidental or consequential damages, so the above limitation or
          exclusion may not apply to you. This Limited Warranty gives you
          specific legal rights, and you may also have other rights which vary
          from state to state.
        </Paragraph>
      </Wrapper>
    </WarrantyPageContainer>
  </>
)

export default WarrantyPage
